<template>
  <div class="short-video-page">
    <!-- 左上角返回按钮 -->
    <div class="back-btn" @click="onBackClick" aria-label="返回上一页">
      <!-- 可以替换为SVG图标，这里用Unicode箭头 -->
      <span class="back-icon">&#8592;</span>
      <span class="back-text">返回</span>
    </div>
    <div
      v-for="(item, idx) in videos"
      :key="item.id"
      class="video-item-wrapper"
      :class="{ active: idx === currentIndex }"
      @touchstart="onTouchStart($event, idx)"
      @touchmove="onTouchMove($event)"
      @touchend="onTouchEnd($event)"
      ref="videoItems"
    >
      <ShortVideoItem
        :title="item.title"
        :desc="item.desc"
        :video-url="item.videoUrl"
        :cover-url="item.coverUrl"
        :active="idx === currentIndex"
        @videoEnded="onVideoEnded(idx)"
      />
    </div>
  </div>
</template>

<script>
import ShortVideoItem from '@/h5/doucan/components/ShortVideoItem.vue'

export default {
  name: 'ShortVideo',
  components: { ShortVideoItem },
  data () {
    return {
      videos: [

        {
          id: 1,
          title: '救命！这是什么神仙野菜！💚金荞麦叶自带山野清香',
          desc: '凉拌酸酸辣辣超开胃，炒鸡蛋香到舔盘！重点是低脂高营养，吃它比喝十杯奶茶还快乐！宝子们快冲，错过真的会哭！# 舌尖上的春天 #吃货日常',
          videoUrl: 'https://cdn.keihong.tech/img/20250524170828002.mp4',
          coverUrl: 'https://cdn.keihong.tech/img/20250524170919494.jpeg'
        },
        {
          id: 4,
          title: '以前喂猪的草，现在却有这么高的待遇',
          desc: '三高人群的救星来了！🔥金荞麦叶搭配玉米须煲汤，天然的 "血管清道夫"！常喝稳血糖、降血压、清血脂，轻松和三高说拜拜～养生党快收藏！# 三高调理 #健康养生',
          videoUrl: 'https://cdn.keihong.tech/img/20250524175609934.mp4',
          coverUrl: 'https://cdn.keihong.tech/img/20250524170919494.jpeg'
        },
        {
          id: 2,
          title: '宝！发现一款宝藏野菜！🌱',
          desc: '金荞麦叶堪称 "野菜界的全能选手"，煮汤清甜，包饺子超鲜，还能晒干泡茶！营养丰富又低脂，好吃不胖的秘密就靠它啦！快艾特饭搭子安排！# 低脂美食 #野菜新吃法',
          videoUrl: 'https://cdn.keihong.tech/img/20250524171119303.mp4',
          coverUrl: 'https://cdn.keihong.tech/img/20250524171606184.png'
        },
        {
          id: 3,
          title: '家人们！挖到宝了！🌿这金荞麦叶简直是野菜界的六边形战士！',
          desc: '高膳食纤维刮油一绝，维生素含量比柠檬还猛！不管是凉拌、清炒还是涮火锅，一口脆嫩爆汁，减脂期的快乐密码被我找到了！# 野菜天花板 #健康轻食',
          videoUrl: 'https://cdn.keihong.tech/img/20250524174059854.mp4',
          coverUrl: 'https://cdn.keihong.tech/img/20250524171606184.png'
        }

      ],
      currentIndex: 0,
      startY: 0,
      deltaY: 0,
      isDragging: false,
      transitioning: false
    }
  },
  methods: {
    // 返回按钮点击事件，返回上一页
    onBackClick () {
      // 使用Vue Router的返回方法
      this.$router.back()
    },
    onTouchStart (e, idx) {
      if (this.transitioning) return
      this.startY = e.touches[0].clientY
      this.deltaY = 0
      this.isDragging = true
    },
    onTouchMove (e) {
      if (!this.isDragging || this.transitioning) return
      this.deltaY = e.touches[0].clientY - this.startY
      this.updateTransforms(this.deltaY)
    },
    onTouchEnd (e) {
      if (!this.isDragging || this.transitioning) return
      this.isDragging = false
      if (this.deltaY < -50) {
        if (this.currentIndex < this.videos.length - 1) {
          this.animateTo(-window.innerHeight, () => {
            this.currentIndex++
            this.resetTransforms()
          })
        } else {
          this.animateTo(-window.innerHeight, () => {
            this.currentIndex = 0
            this.resetTransforms()
          })
        }
      } else if (this.deltaY > 50) {
        if (this.currentIndex > 0) {
          this.animateTo(window.innerHeight, () => {
            this.currentIndex--
            this.resetTransforms()
          })
        } else {
          this.animateTo(window.innerHeight, () => {
            this.currentIndex = this.videos.length - 1
            this.resetTransforms()
          })
        }
      } else {
        this.animateTo(0, this.resetTransforms)
      }
      this.deltaY = 0
    },
    updateTransforms (deltaY) {
      const items = this.$refs.videoItems
      if (!items) return
      if (items[this.currentIndex]) {
        items[this.currentIndex].style.transition = 'none'
        items[this.currentIndex].style.transform = `translateY(${deltaY}px)`
      }
      if (this.currentIndex > 0 && items[this.currentIndex - 1]) {
        items[this.currentIndex - 1].style.transition = 'none'
        items[this.currentIndex - 1].style.transform = `translateY(${-window.innerHeight + deltaY}px)`
      }
      if (this.currentIndex < this.videos.length - 1 && items[this.currentIndex + 1]) {
        items[this.currentIndex + 1].style.transition = 'none'
        items[this.currentIndex + 1].style.transform = `translateY(${window.innerHeight + deltaY}px)`
      }
    },
    animateTo (targetY, cb) {
      const items = this.$refs.videoItems
      this.transitioning = true
      if (items[this.currentIndex]) {
        items[this.currentIndex].style.transition = 'transform 0.4s cubic-bezier(0.4,0,0.2,1)'
        items[this.currentIndex].style.transform = `translateY(${targetY}px)`
      }
      if (this.currentIndex > 0 && items[this.currentIndex - 1]) {
        items[this.currentIndex - 1].style.transition = 'transform 0.4s cubic-bezier(0.4,0,0.2,1)'
        items[this.currentIndex - 1].style.transform = `translateY(${-window.innerHeight + targetY}px)`
      }
      if (this.currentIndex < this.videos.length - 1 && items[this.currentIndex + 1]) {
        items[this.currentIndex + 1].style.transition = 'transform 0.4s cubic-bezier(0.4,0,0.2,1)'
        items[this.currentIndex + 1].style.transform = `translateY(${window.innerHeight + targetY}px)`
      }
      setTimeout(() => {
        this.transitioning = false
        cb && cb()
      }, 400)
    },
    resetTransforms () {
      const items = this.$refs.videoItems
      if (!items) return
      for (let i = 0; i < items.length; i++) {
        items[i].style.transition = 'none'
        if (i === this.currentIndex) {
          items[i].style.transform = 'translateY(0)'
        } else if (
          (this.currentIndex === 0 && i === items.length - 1)
        ) {
          items[i].style.transform = `translateY(${-window.innerHeight}px)`
        } else if (
          (this.currentIndex === items.length - 1 && i === 0)
        ) {
          items[i].style.transform = `translateY(${window.innerHeight}px)`
        } else if (i < this.currentIndex) {
          items[i].style.transform = `translateY(${-window.innerHeight}px)`
        } else {
          items[i].style.transform = `translateY(${window.innerHeight}px)`
        }
      }
    },
    onVideoEnded (idx) {
      if (idx !== this.currentIndex) return
      if (this.currentIndex < this.videos.length - 1) {
        this.currentIndex++
      } else {
        this.currentIndex = 0
      }
    }
  },
  mounted () {
    this.$nextTick(this.resetTransforms)
  },
  watch: {
    currentIndex () {
      this.$nextTick(this.resetTransforms)
    }
  }
}
</script>

<style scoped>
.short-video-page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #000;
  position: relative;
}
.video-item-wrapper {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  transition: none;
  opacity: 1;
  pointer-events: none;
  z-index: 1;
}
.video-item-wrapper.active {
  pointer-events: auto;
  z-index: 2;
}
.back-btn {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 10;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border-radius: 20px;
  padding: 6px 14px 6px 10px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;
}
.back-btn:active {
  background: rgba(0, 0, 0, 0.7);
}
.back-icon {
  font-size: 18px;
  margin-right: 6px;
}
.back-text {
  font-size: 15px;
}
</style>
